import type { CoinView } from './model';
import { predictionMultiplier } from './predictionState';

export interface CrowdSideData {
  count: number | null;
  share: number | null;
  multiplier: number | null;
}

export function crowdState(
  coin: Pick<CoinView, 'split' | 'votes' | 'votesUp'>,
) {
  const validCounts =
    coin.votes !== null &&
    coin.votesUp !== null &&
    Number.isSafeInteger(coin.votes) &&
    Number.isSafeInteger(coin.votesUp) &&
    coin.votes >= 0 &&
    coin.votesUp >= 0 &&
    coin.votesUp <= coin.votes;
  const up = validCounts ? coin.votesUp : null;
  const down = validCounts ? coin.votes! - coin.votesUp! : null;
  const empty = validCounts && coin.votes === 0;
  const split =
    coin.split !== null &&
    Number.isFinite(coin.split) &&
    coin.split >= 0 &&
    coin.split <= 100
      ? coin.split
      : null;
  // A simulator's starting split is not evidence of participants. Conversely,
  // hidden/missing counts must never be replaced with a fabricated zero.
  const kind = empty ? 'empty' : split === null ? 'unavailable' : 'active';
  const side = (count: number | null, run: boolean): CrowdSideData => ({
    count,
    share: empty ? 0 : split === null ? null : run ? split : 100 - split,
    multiplier: empty
      ? null
      : predictionMultiplier({ split, choice: run ? 'SURVIVES' : 'DIES' }),
  });
  return { kind, down: side(down, false), up: side(up, true) };
}
